import * as types from '../constants/ActionTypes';

export const initialState = {
    errorMsg: '',
    errorType: '',
    favouriteOnly: false,
    homeworkCount: 0,
    homeworkList: [],
    homeworkSaved: true,
    loaded: true,
    message: '',
    page: 1,
    showFavouriteToggle: false
};

export default function Homework(state = initialState, action = {}) {
    switch (action.type) {
        case types.SAVE_HOMEWORK:
            return {
                ...state,
                homeworkSaved: false
            };
        case types.SAVE_HOMEWORK_SUCCESS:
            return {
                ...state,
                homeworkList: [],
                ...action.homework,
                id: action.homeworkId,
                saved: true,
                message: "Verifica salvata all'interno del tuo archivio!",
                homeworkId: action.homeworkId,
                homeworkSaved: true
            };
        case types.SAVE_HOMEWORK_FAILURE:
            return {
                ...state,
                message: 'Si sono verificati errori nel salvataggio della verifica',
                homeworkSaved: true
            };
        case types.GET_HOMEWORK_LIST:
            return {
                ...state,
                favouriteOnly: action.payload.favouriteOnly,
                homeworkCount: 0,
                homeworkList: [],
                loaded: false,
                page: 1
            };
        case types.GET_HOMEWORK_LIST_SUCCESS:
            if (action.payload.result.length < 1) {
                return {
                    ...state,
                    errorMsg: `Non sono presenti compiti nell'archivio.`,
                    errorType: '',
                    homeworkCount: 0,
                    loaded: true,
                    showFavouriteToggle: !state.favouriteOnly ? false : true
                };
            } else {
                return {
                    ...state,
                    errorMsg: '',
                    errorType: '',
                    homeworkCount: action.payload.totalCount,
                    homeworkList: action.payload.result,
                    loaded: true,
                    showFavouriteToggle: true
                };
            }
        case types.GET_HOMEWORK_LIST_FAILURE:
            return {
                ...state,
                loaded: true,
                showFavouriteToggle: false
            };
        case types.GET_MORE_HOMEWORK_LIST: {
            return {
                ...state,
                favouriteOnly: action.payload.favouriteOnly,
                loaded: false
            };
        }
        case types.GET_MORE_HOMEWORK_LIST_SUCCESS: {
            return {
                ...state,
                errorMsg: '',
                errorType: '',
                homeworkList: state.homeworkList.concat(
                    action.payload.result.map(userHomework => ({
                        ...userHomework
                    }))
                ),
                loaded: true,
                page: action.payload.searchPage,
                showFavouriteToggle: true
            };
        }
        case types.GET_MORE_HOMEWORK_LIST_FAILURE: {
            return {
                ...state,
                loaded: true,
                showFavouriteToggle: false
            };
        }
        case types.DELETE_HOMEWORK:
            return {
                ...state,
                loaded: false
            };
        case types.DELETE_HOMEWORK_SUCCESS:
            return {
                ...state,
                loaded: true,
                homeworkList: action.homeworkList
            };
        case types.DELETE_HOMEWORK_FAILURE:
            return {
                ...state,
                loaded: true,
                message: "Si sono verificati errori nell'eliminazione della verifica"
            };
        default:
            return state;
    }
}
